import { cacheKey } from '@/constants/cache-key';
import { type IApiResponse } from '@/helpers/types';
import {
	type IGetVolunteerStatusResponse,
	type IVolunteerData,
	type IVolunteerEDStats,
	type IVolunteerStatsResponse,
} from '@/interface/state/IVolunteer';
import { getCommandQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

export const volunteerApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createVolunteer: builder.mutation<IApiResponse, { firstName: string; lastName: string; email: string; phoneNumber: string }>({
			query: (body) => ({
				method: 'POST',
				url: '/Volunteer',
				body,
			}),
		}),
		getVolunteer: builder.mutation<IApiResponse<IVolunteerData[]>, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/Volunteer${getCommandQuery(paged, ...(query || []))}`,
				method: 'GET',
			}),
		}),
		getVolunteerRightSection: builder.mutation<IApiResponse<IVolunteerData[]>, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/Volunteer${getCommandQuery(paged, ...(query || []))}`,
				method: 'GET',
			}),
		}),
		getVolunteerStatus: builder.mutation<IApiResponse<IGetVolunteerStatusResponse[]>, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/VolunteerStatus${getCommandQuery(paged, ...(query || []))}`,
				method: 'GET',
			}),
		}),
		getVolunteerStats: builder.mutation<IVolunteerEDStats, { electionId: string; partyId: string }>({
			query: ({ electionId, partyId }) => ({
				url: `/Volunteer/get-dashboard-data?electionId=${electionId}&partyId=${partyId}`,
				method: 'GET',
			}),
		}),
		getVolunteerDashboardData: builder.mutation<IVolunteerStatsResponse, IGetQuery>({
			query: ({ paged, query }) => ({
				url: `/Volunteer/get-dashboard-data${getCommandQuery(paged, ...(query || []))}`,
				method: 'GET',
			}),
		}),
		getVolunteerById: builder.query<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/Volunteer/${id}`,
			}),
		}),
		approveVolunteer: builder.query<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				url: `/Volunteer/approve/${id}`,
			}),
		}),
		deleteVolunteer: builder.mutation<IApiResponse, { id: string }>({
			query: ({ id }) => ({
				method: 'DELETE',
				url: `/Volunteer/delete/${id}`,
			}),
		}),
	}),
});

export const {
	useCreateVolunteerMutation,
	useApproveVolunteerQuery,
	useLazyApproveVolunteerQuery,
	useDeleteVolunteerMutation,
	useGetVolunteerByIdQuery,
	useGetVolunteerDashboardDataMutation,
	useGetVolunteerMutation,
	useGetVolunteerStatsMutation,
	useGetVolunteerRightSectionMutation,
} = volunteerApiSlice;

export const selectVolunteerDashboardData = volunteerApiSlice.endpoints.getVolunteerDashboardData.select({
	fixedCacheKey: cacheKey.GET_VOLUNTEER_DASHBOARD_DATA,
	requestId: '',
});

export const selectVolunteerData = volunteerApiSlice.endpoints.getVolunteer.select({
	fixedCacheKey: '',
	requestId: '',
});

export const selectVolunteerStatusdData = volunteerApiSlice.endpoints.getVolunteerStatus.select({
	fixedCacheKey: '',
	requestId: '',
});
